import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import {
  NbAuthComponent,
  NbLoginComponent,
  NbLogoutComponent,
} from '@nebular/auth';
import { RegisterComponent } from './auth/register/register.component'
import { AuthGuardService } from './shared/auth-guard.service';
import { OTPComponent } from './auth/otp/otp.component';
import { changePasswordComponent } from "./auth/changePassword/changePassword.component";
import { ForgotPasswordComponent } from './auth/Forgot-password/forgot-password.component'
import { resetPasswordComponent } from './auth/Reset-password/reset-password.component';
import { ApplyComponent } from './apply/apply.component';
import { AdminOtpComponent } from './pages/admin-dashboard/admin-otp/admin-otp.component';
import { GetPasswordComponent } from './auth/get-password/get-password.component';
import { HelpComponent } from './help/help.component';
import { AdminloginComponent } from './admin/adminlogin/adminlogin.component';
import { AdminComponent } from './admin/admin.component';
import { PaymentSuccessComponent } from './payment-success/payment-success.component';
import { FirstFailureComponent } from './payment-success/FirstFailure.component';
import { FirstCancelComponent } from './payment-success/FirstCancel.component';

const routes: Routes = [
  // {path:'apply', component: ApplyComponent},
  {path:'PaymentSuccess', component: PaymentSuccessComponent},
  {path:'PaymentFailure', component: FirstFailureComponent},
  {path:'FirstCancel', component: FirstCancelComponent},
  // {path:'help', component: HelpComponent},
  {path:'adminLogin', component: AdminloginComponent},
  // {path:'admin', component: AdminComponent},
  { path: 'pages',canActivate: [AuthGuardService], loadChildren: 'app/pages/pages.module#PagesModule' },
  {
    path: 'auth',
    component: NbAuthComponent,
    children: [
      {
        path: '',
        component: NbLoginComponent,
      },
      {
        path: 'login',
        component: NbLoginComponent,
      },
      {
        path: 'register',
        component: RegisterComponent,
      },
      {
        path: 'logout',
        component: NbLogoutComponent,
      },
      {
        path: 'request-password',
        component: ForgotPasswordComponent,
      },
      {
        path: 'reset-password',
        component: resetPasswordComponent,
      },
      {
        path: 'otp',
        component: OTPComponent,
      },
      {
        path: 'changePassword',
        component: changePasswordComponent,
      },
      {
        path: 'adminOtp',
        component: AdminOtpComponent,
    
      }, 
      {
        path: 'getpassword',
        component: GetPasswordComponent,
      }, 
    ],
  },
  { path: '', redirectTo: 'pages', pathMatch: 'full' },
  { path: '**', redirectTo: 'pages' },
  
];

const config: ExtraOptions = {
  useHash: true,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
